import { render } from "./ComponentsForm.vue?vue&type=template&id=32bfabe0"
import script from "./ComponentsForm.vue?vue&type=script&lang=js"
export * from "./ComponentsForm.vue?vue&type=script&lang=js"

import "./ComponentsForm.vue?vue&type=style&index=0&id=32bfabe0&lang=css"

import exportComponent from "C:\\Git\\whistleblowing_FE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__